module.exports = __webpack_public_path__ + "static/media/aragon01.d5c64417.jpg";